module.exports = __webpack_public_path__ + "img/partner01.7710be41.png";